import { useCallback, useEffect, useState } from 'react';
import { getSubscriptionPrice } from '@/services/payment/payment.service';
import { Product } from '@/core/models';

const useSubscriptionPrice = (id: string) => {
   const [product, setProduct] = useState<Product | null>(null);
   const [price, setPrice] = useState<number | null>(null);

   const fetchSubscription = useCallback(async (id: string) => {
      const [error, data] = await getSubscriptionPrice(id);
      if (error) {
         console.log(error);
         setProduct(null);
         return;
      }

      setProduct(data.response);
      setPrice(data.response.priceDetails.amount / 100);
   }, []);

   useEffect(() => {
      if (id) fetchSubscription(id);
   }, [fetchSubscription, id]);

   return { product, price, setPrice };
};

export default useSubscriptionPrice;
